
import React from 'react';
import { Row, Col, Container } from "reactstrap";
import * as Sentry from "@sentry/react";


export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Actualiza el estado para que el siguiente renderizado muestre la interfaz de repuesto
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // También puedes registrar el error en un servicio de reporte de errores
        Sentry.captureException(new Error("Error: " + errorInfo), {
            level: "error"
        });
    }

    render() {
        if (this.state.hasError) {
            // Puedes renderizar cualquier interfaz de repuesto
            return (<Container>
                <Row className=" justify-content-start mt-4 ">
                    <h1 className="mb-4 w-100 text-center">Ha ocurrido un error inesperado</h1>
                </Row>
            </Container>)
        }

        return this.props.children;
    }
}